var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label}},[_c('b-form-input',{attrs:{"placeholder":_vm.placeholder,"trim":""},on:{"input":_vm.applyFilter,"keypress":function($event){_vm.restrictInput ? _vm.isRestricted($event) : null}},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }